import { Component, OnInit, ViewEncapsulation } from '@angular/core';
declare var $: any;

@Component({
    selector: 'ups-dashboard-accordeon-head-qv',
    template: require('./ups-dashboard-accordeon-head-qv.component.html'),
    encapsulation: ViewEncapsulation.None
})
export class UpsDashboardAccordeonHeadQVComponent implements OnInit {

    ngOnInit() {

    }

}


